var map = {
	"./Background-HomePage.jpg": 7859,
	"./Card-0-Section-2-HomePage-chambre-1.jpeg": 1333,
	"./Card-0-Section-2-HomePage-chambre-2.jpeg": 1060,
	"./Card-0-Section-2-HomePage-chambre-3.jpeg": 747,
	"./Card-0-Section-2-HomePage.jpeg": 5482,
	"./Card-1-HomePage-2.jpeg": 2999,
	"./Card-1-HomePage-3.jpeg": 5296,
	"./Card-1-HomePage.jpeg": 4468,
	"./Card-1-Section-2-HomePage-chambre-1.jpeg": 2472,
	"./Card-1-Section-2-HomePage-chambre-2.jpeg": 7913,
	"./Card-1-Section-2-HomePage-chambre-3.jpeg": 2050,
	"./Card-1-Section-2-HomePage.jpeg": 1911,
	"./Card-1-chambre-1.jpeg": 9674,
	"./Card-1-chambre-2.jpeg": 663,
	"./Card-1-chambre-3.jpeg": 1088,
	"./Card-1-chambre-4.jpeg": 213,
	"./Card-10-Section-2-HomePage.jpeg": 509,
	"./Card-11-Section-2-HomePage.jpeg": 7960,
	"./Card-2-Section-2-HomePage.jpeg": 5384,
	"./Card-3-Section-2-HomePage.jpeg": 5293,
	"./Card-4-Section-2-HomePage-chambre-1.jpeg": 6505,
	"./Card-4-Section-2-HomePage-chambre-2.jpeg": 1064,
	"./Card-4-Section-2-HomePage-chambre-3.jpeg": 1583,
	"./Card-4-Section-2-HomePage-chambre-4.jpeg": 4662,
	"./Card-4-Section-2-HomePage.jpeg": 7774,
	"./Card-5-Section-2-HomePage.jpeg": 1947,
	"./Card-6-Section-2-HomePage.jpeg": 5308,
	"./Card-7-Section-2-HomePage.jpeg": 3153,
	"./Card-8-Section-2-HomePage.jpeg": 2450,
	"./Card-9-Section-2-HomePage.jpeg": 4767,
	"./Card-Section-4-about.png": 7835,
	"./cards-About-1.jpg": 3145,
	"./cards-About-2.jpg": 6030,
	"./icone-1.png": 9840,
	"./icone-2.png": 9691,
	"./icone-3.png": 8562,
	"./icone-4.png": 4909,
	"./icone-5.png": 3780,
	"./icone-6.png": 2687,
	"./login-bg.jpg": 3045,
	"./login2-bg.jpg": 6631,
	"./logo.png": 9729,
	"./section-3-about.jpg": 5387,
	"./team-1.png": 7373,
	"./team-2.png": 1958,
	"./team-3.png": 5759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4082;